module.exports = __webpack_public_path__ + "img/h5.9257f5da.png";